import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { RefAttributes } from 'react';
import type { TinyEditPageDataLoaderActions, TinyEditPageDataLoaderOwnProps } from './types.ts';

type TinyEditPageDataLoaderAnalyticsProp = 'createAnalyticsEvent';

export const TinyEditPageDataLoaderLoader: LoadableType<
	Omit<
		Omit<
			TinyEditPageDataLoaderActions & TinyEditPageDataLoaderOwnProps,
			TinyEditPageDataLoaderAnalyticsProp
		> &
			RefAttributes<any>,
		'getEditorContentMetadata'
	>
> = LoadableAfterPaint({
	loader: () =>
		import(/* webpackChunkName: "loadable-EditPageDataLoader" */ './TinyEditPageDataLoader.tsx'),
});
